<template>
  <base-popover>
    <template v-slot:icon>
      <cog-icon class="w-5 h-5 text-gray-500" />
    </template>
    <div class="space-y-4">
      <base-input v-for="(type, idx) in types" :key="`type-${idx}`" :label="type.name">
        <el-select :options="componentConfigOptions.filter(c => c.type == type.name)" :value="componentConfig[type.slug]" @input="setTypeValue($event, type.slug)" />
      </base-input>
    </div>
  </base-popover>
</template>
<script>
/*
  TODO: convert into json array of objects
  if value is array of strings. convert to array of objects
*/
import {
  CogIcon,
} from '@vue-hero-icons/solid';
import Form from '../Form'
import { BasePopover } from '../Base';
export default {
  components: {
    CogIcon,
    BasePopover,
    ...Form,
  },
  props: {
    value: null,
    componentConfigs: {
      type: [Array],
      default: () => [],
    },
    componentConfigTypes: {
      type: [Array],
      default: () => [],
    },
  },
  computed: {
    componentConfig() {
      if (typeof this.value === 'string') {
        return JSON.parse(this.value);
      } else if (this.value === null) {
        return {};
      } else {
        return this.value;
      }
    },
    types() {
      return this.componentConfigTypes.map(t => { return {name: t, slug: String(t).toLowerCase().replace(/ /g, '_')}})
    },
    componentConfigOptions() {
      return this.componentConfigs.map(c => {return {label: `${c.name} (${c.css_classes})`, value: c.css_classes, type: c.type}})
    },
  },
  methods: {
    setTypeValue(evt, typeSlug) {
      // if (Array.isArray(this.componentConfig) && this.componentConfig.length) {
      //   let newVal = this.componentConfig.filter(v => v != this.getTypeValue(type));
      //   newVal.push(evt);
      //   this.$emit('input', newVal.filter(v => v.length));
      // } else {
      //   this.$emit('input', [evt].filter(v => v.length));
      // }
      const cc = JSON.parse(JSON.stringify(this.componentConfig));
      cc[typeSlug] = evt;
      this.$emit('input', cc);
    }
  },
  mounted() {
    if (Array.isArray(this.componentConfig)) {
      // TODO: convert array into object
      const newVal = {};
      this.componentConfig.forEach(v => {
        const matches = this.componentConfigs.filter(cc => {
          return cc.css_classes == v;
        });
        if (matches.length) {
          newVal[String(matches[0].type).toLowerCase().replace(/ /g, '_')] = v;
        }
      });
      return this.$emit('input', newVal);
    }
  }
}
</script>
